// ====================================================================================
// scrollToTop.module
// ====================================================================================

const button = document.querySelector(".scroll-to-top");
const header = document.querySelector(".header");
const footerBottom = document.querySelector(".footer__bottom");

const elementIsInViewport = (el) => {
  if (!el) return false;
  const { top, bottom } = el.getBoundingClientRect();
  const { innerHeight } = window;
  return (
    (top >= 0 && top <= innerHeight) || (bottom >= 0 && bottom <= innerHeight)
  );
};

const updateScrollToTop = () => {
  let scrollTop = window.scrollY || document.documentElement.scrollTop;

  if (footerBottom) {
    let winWidth = window.innerWidth;
    if (winWidth <= 420) {
      let visible = elementIsInViewport(footerBottom, true);
      console.log("visible", visible);
      if (elementIsInViewport(footerBottom, true)) {
        button.style.bottom = footerBottom.clientHeight + 5 + "px";
      } else {
        button.style.bottom = "";
      }
    }
  }

  if (scrollTop > header.clientHeight) {
    button.classList.add("active");
  } else {
    button.classList.remove("active");
  }
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const init = () => {
  if (!button) return;

  updateScrollToTop();

  button.addEventListener("click", scrollToTop);
  document.addEventListener("resize", updateScrollToTop);
  document.addEventListener("scroll", updateScrollToTop);
  document.addEventListener("load", updateScrollToTop);
};
